module.exports = "/_next/static/images/clientCentricWaterUtilitySolutions-7272f8927ac09b7700c45bdb6847fc68.webp";